// extracted by mini-css-extract-plugin
module.exports = {"headingBlock":"HeroHeadingBlock_headingBlock__BGjoj","subtitleText":"HeroHeadingBlock_subtitleText__3G0t7"};